import { Link } from 'react-router-dom';
import { siteInfo, comics } from '@/mocks/comics';

export default function StatsSection() {
  const completedCount = comics.filter((c) => c.status === '已完结').length;
  const ongoingCount = comics.filter((c) => c.status === '连载中').length;

  const stats = [
    { label: '漫画总数', value: `${siteInfo.comicCount.toLocaleString()}+`, icon: 'ri-book-2-line' },
    { label: '连载中', value: `${ongoingCount}+`, icon: 'ri-loader-4-line' },
    { label: '已完结', value: `${completedCount}+`, icon: 'ri-check-double-line' },
    { label: '日活用户', value: `${(siteInfo.dailyUsers / 10000).toFixed(0)}万+`, icon: 'ri-user-heart-line' },
  ];

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="bg-accent-500 rounded-2xl p-8 md:p-12">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
            为什么选择韩漫网？
          </h2>
          <p className="text-background-100/80 text-sm md:text-base max-w-xl mx-auto">
            我们致力于提供最优质的韩国漫画阅读体验，让每一位漫迷都能享受阅读的乐趣
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/20">
                <i className={`${stat.icon} text-xl text-background-50`}></i>
              </div>
              <p className="text-3xl md:text-4xl font-bold text-background-50 font-heading mb-1">
                {stat.value}
              </p>
              <p className="text-sm text-background-100/80">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}